import { useCallback, useMemo } from 'react';
import { resolveTeamVisual, type ResolveTeamVisualInput, type TeamVisual } from '../cfbBranding/teamVisualResolver';
import { useCfbSchoolCatalog } from './useCfbSchoolCatalog';
import { useLeague } from './useLeague';

export function useTeamVisualResolver() {
  const { league } = useLeague();
  const cfbCatalog = useCfbSchoolCatalog();
  const gameKey = league?.game_key ?? null;

  const cfbCatalogIndex = useMemo(() => {
    if (gameKey !== 'cfb') {
      return null;
    }
    return cfbCatalog?.index ?? null;
  }, [cfbCatalog?.index, gameKey]);

  return useCallback(
    (input: Omit<ResolveTeamVisualInput, 'gameKey' | 'cfbCatalogIndex'>): TeamVisual =>
      resolveTeamVisual({
        ...input,
        gameKey,
        cfbCatalogIndex,
      }),
    [cfbCatalogIndex, gameKey]
  );
}
